module.exports = __webpack_public_path__ + "img/logo_pc-white.b28aa735.svg";